import React from "react";
import { Route } from "react-router";
import ConfirmRegistration from "../components/ConfirmRegistration";
import ResetPassword from "../components/ResetPassword";
import ConfirmInviteRegistration from "../components/ConfirmInviteRegistration";
import AccountLayout from "../components/AccountLayout";
import LoginPage from "../components/login/LoginPage";
import ForgotPasswordPage from "../components/ForgotPasswordPage";
import StartRegistrationPage from "../components/StartRegistrationPage";
import InviteOnlyPage from "../components/InviteOnlyPage";
import { UnauthorizedRoute } from "../../shared/components/Routers";
import { isComAppHost } from "../../shared/utils/hostPolicy";

/**
 * HOST_POLICY_SPEC §6 FE-B — on the `.com` app hosts MachineID is invite-only, so the two SELF-
 * registration routes render the invite-only page instead of the registration flow. Same paths, a
 * different page: existing links and bookmarks keep working and land somewhere that explains itself
 * rather than on a form that would 403.
 *
 * `confirm-invite-registration` is deliberately UNCHANGED — an invite IS the `.com` on-ramp.
 *
 * UX only. The server (Customers) refuses registration off the `.cc` surface regardless.
 */
const useAccountRoutes = () => {
  const isComHost = isComAppHost();

  return (
    <Route path="" element={<UnauthorizedRoute />}>
      <Route path="" element={<AccountLayout />}>
        <Route path="sign-in" element={<LoginPage />}></Route>
        <Route path="sign-up" element={isComHost ? <InviteOnlyPage /> : <StartRegistrationPage />}></Route>
        <Route path="forgot-password" element={<ForgotPasswordPage />}></Route>
        {/* A `.cc` confirmation link pasted onto a `.com` host: the API refuses it anyway, so show
            the explanation rather than a form that cannot succeed. */}
        <Route path="confirm-registration" element={isComHost ? <InviteOnlyPage /> : <ConfirmRegistration />}></Route>
        <Route path="confirm-invite-registration" element={<ConfirmInviteRegistration />}></Route>
        <Route path="reset-password" element={<ResetPassword />}></Route>
      </Route>
    </Route>
  );
};

export default useAccountRoutes;